<template>
    <v-card class="white border-boxGlobal">
        <v-card-title> Ajuste de Inventario </v-card-title>

        <v-row class="mx-1">
            <!--   <v-col cols="12" class="d-flex justify-end">
              
                <v-btn class="btnclean" @click="showFilter = true" >Filtros</v-btn>
            </v-col> -->
        </v-row>
        <block v-if="loading"></block>
        
        <VersatileFilter :columnsSearch="columsConfig" :search="search" @emptyFilter="getEarningDetail" 
            @filtered="filterHandler" :key="Reloadfilter" :useCache="true"
            @updateCache="updateCache" class="mx-3" :oneDateFilter="true"
            :columnfilterEndpoint="$API.inventoryReports.getInventoryFilterReportColumn">
                <DxDataGrid class="isScrolledByGeneralFilter" :data-source="reportsData" :show-borders="true"
                    @exporting="onExporting" @selectionChanged="selectionChanged" :scrolling="{ useNative: true }"
                    :column-auto-width="true">
                    <DxExport :enabled="true" />
                    <DxColumn cell-template="seeDetail" />
                    <DxColumn data-field="ID_Item" caption="ID Producto" />
                    <DxColumn data-field="PrincipalBarCode" caption="Código Alterno Principal" />
                    <DxColumn data-field="ItemName" caption="Nombre Producto" />
                    <DxColumn data-field="Lote" caption="Lote" />
                    <DxColumn v-if="$store.getters['rolesUser/getArrayCustomRole']([242])" data-field="LastPurchaseDate" caption="Última Fecha de compra" />
                    <DxColumn v-if="$store.getters['rolesUser/getArrayCustomRole']([242])" data-field="LastPurchasePrice" caption="Último Costo de compra" />
                    <DxColumn v-if="$store.getters['rolesUser/getArrayCustomRole']([242])" data-field="CostoPromedio" caption="Costo promedio" />
                    <DxColumn data-field="Providers" caption="Proveedores" />
                    <DxColumn data-field="WarehouseName" caption="Almacén" />
                    <DxColumn data-field="ItemMeasureUnit" caption="Unidad" />
                    <DxColumn data-field="ItemMinimum" caption="Minimo" />
                    <DxColumn data-field="ItemMaximum" caption="Maximo" />
                    <DxColumn data-field="TotalStock" :width="100" caption="Disponible" />

                    <template #seeDetail="{ data }">
                       <div class="action-btns-gap">
                        <v-btn class="btn-save" href="#" @click.prevent.stop="openAdjustment(data.data)"><v-icon color="white" class="mr-2">mdi-package-variant-closed</v-icon>Hacer Ajuste
                        </v-btn>
                        <v-btn class="btn-save" href="#" @click.prevent.stop="openAdjustmentsManager(data.data)">
                            <v-icon color="white" class="mr-2">mdi-history</v-icon>Gestión de Ajustes
                        </v-btn>
                        <v-btn class="btn-save" href="#" @click.prevent.stop="
                            selectedReport = data.data;
                            showEditAmount = false;
                            $nextTick(() => { showEditAmount = true; });
                        "><v-icon color="white" class="mr-2">mdi-pencil</v-icon>Editar Costo
                        </v-btn>
                       </div>
                    </template>

                    <DxPager :showPageSizeSelector="true" :allowedPageSizes="[10, 30, 50]" />

                    <DxPaging :page-size="10" />
                </DxDataGrid>
        </VersatileFilter>

        <v-dialog v-model="showReport" max-width="80%" scrollable content-class="inventory-adjustment-dialog">
            <v-card class="border" style="max-height: inherit;overflow-y: scroll;" >
                <v-btn @click="showReport= false" elevation="0" color="red" class="close-btn align-self-end"><v-icon>mdi-close</v-icon></v-btn>
                <div v-if="selectedReport" class="pa-10">
                    <v-row>
                        <v-col cols="12" md="4">
                            <date-picker label="Fecha Ajuste" @dateSelected="changueDt" v-model="form.date"
                                :value="form.date" /> 
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12">
                            <h3>Detalle de Producto</h3>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col col="12" md="4" xl="4">
                            <span>
                                <strong>ID Producto: </strong>
                                {{ selectedReport.ID_Item }}
                            </span>
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <span>
                                <strong>Nombre: </strong>
                                {{ selectedReport.ItemName }}
                            </span>
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <span>
                                <strong>Almacén: </strong>
                                {{ selectedItemWarehouseName }}
                            </span>
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <span>
                                <strong>Unidad: </strong>
                                {{ selectedReport.ItemMeasureUnit }}
                            </span>
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <span>
                                <strong>Lote: </strong>
                                {{ selectedReport.Lote ? selectedReport.Lote : "Por defecto" }}
                            </span>
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <span>
                                <strong>Último precio ingresado: </strong>
                                {{
                                    selectedReport.LastPrice
                                }}
                            </span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12">
                            <h3>Parametros de ingreso</h3>
                        </v-col>
                        <v-col cols="12" md="4">
                          
                            <v-radio-group  v-model="form.add" row>
                                <v-radio label="Agregar existencia" :value="true"></v-radio>
                                <v-radio label="Restar existencia" :value="false"></v-radio>                           
                            </v-radio-group>
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <v-text-field
                                v-model="form.quantity"
                                label="Cantidad"
                                outlined
                                dense
                                type="number"
                                min="0"
                                :rules="quantityRules"
                                @input="normalizeQuantity"
                            />
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <v-text-field v-model="getsetAverageCost" label="Costo unitario de Compra"  outlined dense />
                            
                           
                        </v-col>

                    </v-row>
                    <v-row>
                       
                       
                        <v-col col="12" md="4" xl="4">
                            <v-text-field v-model="getsetLote" label="Lote" outlined dense />
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <v-select v-model="getsetWarehouse" label="Almacén"
                                :items="datafilter.Warehouses" item-text="name" item-value="value"  attach
                            outlined dense />
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <v-btn @click="showComments = !showComments" :class="form.comment ? 'btnclean' : 'btnblack'">
                                Comentarios
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <h2>
                                {{ "Existencias Actuales: " + stockToShow }}
                            </h2>
                        </v-col>
                        <v-col cols="12" md="6">
                            <h2>
                                {{ "Existencias Nuevas: " + totalStock }}
                            </h2>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions class="mt-3">
                    <v-btn @click="showReport = false" class="btndelete">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="btn-save"
                        :loading="loading"
                        :disabled="loading || !isValidQuantity || !hasAdjustmentDate"
                        @click="sendAdjustment"
                    >Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showComments" max-width="80%">
            <v-card>
                <div style="
            margin-top: 0.3rem;
            margin-bottom: 0.3rem;
            display: flex;
            justify-content: flex-end;
          ">
                    <v-btn small class="btndelete" @click.prevent="showComments = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
                <v-col cols="12" md="12" style="">
                    <quill-editor v-model="form.comment"></quill-editor>
                </v-col>
            </v-card>
        </v-dialog>

        <EditAmountDialog
          :key="showEditAmount ? (selectedReport && selectedReport.ID_Item) : 'closed'"
          :show="showEditAmount"
          :item="selectedReport"
          :warehouses="datafilter.Warehouses"
          :initialWarehouse="selectedReport ? (selectedReport.Warehouse || selectedReport.ID_Warehouse) : null"
          @update:show="showEditAmount = $event"
          @save="handleEditAmountSave"
        />

        <v-dialog v-model="showAdjustmentsManager" max-width="90%" scrollable content-class="inventory-adjustments-modal">
            <v-card class="border" style="max-height: inherit; overflow-y: auto;">
                <v-btn @click="showAdjustmentsManager = false" elevation="0" color="red" class="close-btn align-self-end">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <div class="pa-6">
                    <v-row>
                        <v-col cols="12">
                            <h3>Gestión de Ajustes</h3>
                        </v-col>
                    </v-row>
                    <br/>
                    <br/>
                    <v-row v-if="selectedReport">
                        <v-col cols="12" md="3">
                            <strong>ID Producto:</strong> {{ selectedReport.ID_Item }}
                        </v-col>
                        <v-col cols="12" md="3">
                            <strong>Producto:</strong> {{ selectedReport.ItemName }}
                        </v-col>
                    </v-row>
                    <br/>
                    <v-tabs v-model="adjustmentsTab" class="mt-4" background-color="transparent" color="primary">
                        <v-tab>Historial de Ajustes</v-tab>
                        <v-tab>Historial de Reversiones</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="adjustmentsTab" style="border: #3498db 2px solid; padding: 2px;">
                        <v-tab-item>
                            <v-row class="mt-3">
                                <v-col cols="12">
                                    <v-checkbox
                                        v-model="adjustmentHistoryFilters.filterByDate"
                                        hide-details
                                        label="Filtrar por fecha"
                                    />
                                </v-col>
                            </v-row>
                            <br/>
                            <v-row class="mt-3">
                                <v-col cols="12" md="3" v-if="adjustmentHistoryFilters.filterByDate">
                                    <date-picker
                                        label="Desde"
                                        :value="adjustmentHistoryFilters.startDate"
                                        @dateSelected="adjustmentHistoryFilters.startDate = $event"
                                    />
                                </v-col>
                                <v-col cols="12" md="3" v-if="adjustmentHistoryFilters.filterByDate">
                                    <date-picker
                                        label="Hasta"
                                        :value="adjustmentHistoryFilters.endDate"
                                        @dateSelected="adjustmentHistoryFilters.endDate = $event"
                                    />
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="adjustmentHistoryFilters.searchTerm"
                                        label="Búsqueda general"
                                        placeholder="ID de ajuste, tipo operación, comentario, lote o usuario"
                                        outlined
                                        dense
                                        clearable
                                    />
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select
                                        v-model="adjustmentHistoryFilters.warehouseId"
                                        :items="warehouseFilterOptions"
                                        item-text="name"
                                        item-value="value"
                                        label="Almacén"
                                        outlined
                                        dense
                                    />
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-btn class="btn-add mr-2" :loading="adjustmentsLoading" @click="loadAdjustments">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                    <v-btn class="btnclean" :disabled="adjustmentsLoading" @click="resetAdjustmentFilters">
                                        <v-icon>mdi-filter-remove</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <block v-if="adjustmentsLoading && adjustmentsTab === 0"></block>

                            <DxDataGrid
                                class="isScrolledByGeneralFilter mt-4"
                                :data-source="adjustmentsData"
                                :show-borders="true"
                                :scrolling="{ useNative: true }"
                                :column-auto-width="true"
                                key-expr="ID_Adjustment"
                            >
                                <DxExport :enabled="false" />
                                <DxColumn data-field="ID_Adjustment" caption="ID Ajuste" />
                                <DxColumn data-field="AdjustmentDate" caption="Fecha" />
                                <DxColumn cell-template="typeInOut" caption="Tipo operacion" />
                                <template #typeInOut="{ data }"> 
                                    {{ String(data.data.Item_InOut || "").trim().toUpperCase() == "IN" ? "Entrada" : "" }}
                                    {{ String(data.data.Item_InOut || "").trim().toUpperCase() == "OUT" ? "Salida" : "" }}
                                </template>
                                <DxColumn data-field="Quantity" caption="Cantidad" />
                                <DxColumn data-field="UnitCost" caption="Costo Unitario" />
                                <DxColumn data-field="WarehouseName" caption="Almacén" />
                                <DxColumn data-field="ID_ItemBatch" caption="Lote" />
                                <DxColumn cell-template="commentText" caption="Comentario" />
                                <DxColumn data-field="FullUserName" caption="Usuario" />
                                <DxColumn cell-template="revertAdjustment" caption="Acciones" :width="180" />
                                <template #commentText="{ data }">
                                    <span>{{ stripHtml(data.data.Comment) }}</span>
                                </template>
                                <template #revertAdjustment="{ data }">
                                    <v-btn
                                        small
                                        class="btndelete"
                                        :disabled="adjustmentsLoading || !data.data.CanRevert"
                                        @click.prevent.stop="askRevertAdjustment(data.data)"
                                    >
                                        Revertir ajuste
                                    </v-btn>
                                </template>
                                <DxPager :showPageSizeSelector="true" :allowedPageSizes="[10, 30, 50]" />
                                <DxPaging :page-size="10" />
                            </DxDataGrid>
                        </v-tab-item>
                        <v-tab-item>
                            <v-row class="mt-3">
                                <v-col cols="12">
                                    <v-checkbox
                                        v-model="adjustmentHistoryFilters.filterByDate"
                                        hide-details
                                        label="Filtrar por fecha"
                                    />
                                </v-col>
                            </v-row>
                            <br/>
                            <v-row class="mt-3">
                                <v-col cols="12" md="3" v-if="adjustmentHistoryFilters.filterByDate">
                                    <date-picker
                                        label="Desde"
                                        :value="adjustmentHistoryFilters.startDate"
                                        @dateSelected="adjustmentHistoryFilters.startDate = $event"
                                    />
                                </v-col>
                                <v-col cols="12" md="3" v-if="adjustmentHistoryFilters.filterByDate">
                                    <date-picker
                                        label="Hasta"
                                        :value="adjustmentHistoryFilters.endDate"
                                        @dateSelected="adjustmentHistoryFilters.endDate = $event"
                                    />
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="adjustmentHistoryFilters.searchTerm"
                                        label="Búsqueda general"
                                        placeholder="ID de ajuste, tipo operación, comentario, lote o usuario"
                                        outlined
                                        dense
                                        clearable
                                    />
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select
                                        v-model="adjustmentHistoryFilters.warehouseId"
                                        :items="warehouseFilterOptions"
                                        item-text="name"
                                        item-value="value"
                                        label="Almacén"
                                        outlined
                                        dense
                                    />
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-btn class="btn-add mr-2" :loading="adjustmentsLoading" @click="loadDeletedAdjustments">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                    <v-btn class="btnclean" :disabled="adjustmentsLoading" @click="resetAdjustmentFilters">
                                        <v-icon>mdi-filter-remove</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <block v-if="adjustmentsLoading && adjustmentsTab === 1"></block>

                            <DxDataGrid
                                class="isScrolledByGeneralFilter mt-4"
                                :data-source="deletedAdjustmentsData"
                                :show-borders="true"
                                :scrolling="{ useNative: true }"
                                :column-auto-width="true"
                                key-expr="ID_Adjustment"
                            >
                                <DxExport :enabled="false" />
                                <DxColumn data-field="ID_Adjustment" caption="ID Ajuste" />
                                <DxColumn data-field="AdjustmentDate" caption="Fecha" />
                                <DxColumn cell-template="typeInOut" caption="Tipo operacion" />
                                <template #typeInOut="{ data }"> 
                                    {{ String(data.data.Item_InOut || "").trim().toUpperCase() == "IN" ? "Entrada" : "" }}
                                    {{ String(data.data.Item_InOut || "").trim().toUpperCase() == "OUT" ? "Salida" : "" }}
                                </template>
                                <DxColumn data-field="Quantity" caption="Cantidad" />
                                <DxColumn data-field="UnitCost" caption="Costo Unitario" />
                                <DxColumn data-field="WarehouseName" caption="Almacén" />
                                <DxColumn data-field="ID_ItemBatch" caption="Lote" />
                                <DxColumn cell-template="commentText" caption="Comentario" />
                                <DxColumn data-field="FullUserName" caption="Usuario" />
                                <DxColumn cell-template="reversalDateText" caption="Fecha reversión" />
                                <DxColumn cell-template="restoreAdjustment" caption="Acciones" :width="180" />
                                <template #reversalDateText="{ data }">
                                    <span>{{ formatDisplayDate(data.data.AdjustmentDateReversal) }}</span>
                                </template>
                                <template #commentText="{ data }">
                                    <span>{{ stripHtml(data.data.Comment) }}</span>
                                </template>
                                <template #restoreAdjustment="{ data }">
                                    <v-btn
                                        small
                                        class="btnsave"
                                        :disabled="adjustmentsLoading"
                                        @click.prevent.stop="askRestoreAdjustment(data.data)"
                                    >
                                        Restaurar ajuste
                                    </v-btn>
                                </template>
                                <DxPager :showPageSizeSelector="true" :allowedPageSizes="[10, 30, 50]" />
                                <DxPaging :page-size="10" />
                            </DxDataGrid>
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </v-card>
        </v-dialog>

        <!--   <v-dialog
        v-model="showFilter"
        max-width="80%"
        
       >
        <v-card>
            <v-card-title>
                <h3>Filtros</h3>
            </v-card-title>
            <v-card-text>
                <v-row class="mt-2">
                    <v-col cols="12" md="6">
                        <v-text-field
                            v-model="filterParams.ID_Item"
                            label="ID Producto"
                            outlined dense
                            />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            v-model="filterParams.ItemName"
                            label="Nombre Producto"
                            outlined dense
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            v-model="filterParams.ItemLote"
                            label="Lote"
                            outlined dense
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            v-model="filterParams.providersNames"
                            label="Proveedores"
                            outlined dense
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            v-model="filterParams.WarehouseName"
                            label="Almacen"
                            outlined dense
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions >
                <v-btn @click="
                    showFilter = false;
                    cleanFilter();" >Limpiar</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                 @click="
                 showFilter = false;
                 getFilterEarningDetail()" >Filtrar</v-btn>
            </v-card-actions>

        </v-card>
       </v-dialog> -->
        <v-dialog
            v-model="alert.show"
            content-class="inventory-adjustments-alert-dialog"
            :hide-overlay="true"
            persistent
        >
            <alerts
                class="inventory-adjustments-alert"
                v-on:close_alert="closeAlert"
                v-on:accept_alert="acceptAlert"
                :properties="alert"
            />
        </v-dialog>
    </v-card>
</template>

<script>
import {
    DxDataGrid,
    DxColumn,
    DxExport,
    DxPager,
    DxPaging,
} from "devextreme-vue/data-grid";
import { printToExcel } from "@/helpers/printToexcel";
import VersatileFilter from "@/components/VersatileFilter";
//import GeneralFilter from  "@/components/GeneralFilter";
import Block from "@/components/Block";
import DatePicker from "@/components/DatePicker";
import Alerts from "@/components/Alerts";
import EditAmountDialog from '@/components/EditAmountDialog.vue';

const getTodayAsAdjustmentDate = () => {
    const today = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
    const [year, month, day] = today.split("-");

    return `${day}/${month}/${year}`;
};

const createAdjustmentForm = () => ({
    add: true,
    quantity: null,
    date: getTodayAsAdjustmentDate(),
    warehouse: null,
    lote: null,
    price: null,
    comment: null,
});

export default {
    name: "InventoryPhysicalR",
    components: {
        Block,
        DxDataGrid,
        DxColumn,
        DxPager,
        DxExport,
        DxPaging,
        //  GeneralFilter,
        // DxSelection,
        DatePicker,
        Alerts,
        VersatileFilter,
        EditAmountDialog,
    },
    props: ["win", "datafilter"],
    data() {
        return {
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
            loading: false,
            panel: 0,
            reportsData: [],
            start: null,
            end: null,
            summary: {
                totalUnitSales: 0,
                totalCostSales: 0,
            },
            search: {},
            showFilter: false,
            filterParams: {
                ID_Item: null,
                ItemName: null,
                ItemLote: null,
                providersNames: null,
                WarehouseName: null,
                add: null,
            },
            Reloadfilter: 0,
            columsConfig: [
                {
                    name: "ID_Warehouse",
                    title: "Almacenes",
                    value: "",
                    type: "select",
                    options: [],
                },
                {
                    name: "family",
                    title: "Familia",
                    value: "",
                    type: "select",
                    options: [],
                },
                {
                    name: "category",
                    title: "Categoría",
                    value: "",
                    parent: 'family',
                    type: "select",
                    options: [],
                },
                {
                    name: "subcategory",
                    title: "Subcategoría",
                    value: "",
                    parent: 'category',
                    type: "select",
                    options: [],
                },
                {
                    name: "Lote",
                    title: "Lote",
                    value: "",
                    type: "select",
                    options: [],
                },
            ],
            cacheData: [],
            selectedReport: null,
            form: createAdjustmentForm(),
            showComments: false,
            showReport: false,
            showAdjustmentsManager: false,
            adjustmentsLoading: false,
            adjustmentsData: [],
            deletedAdjustmentsData: [],
            adjustmentsTab: 0,
            adjustmentHistoryFilters: {
                filterByDate: true,
                startDate: null,
                endDate: null,
                warehouseId: "all",
                searchTerm: "",
            },
            pendingRevertAdjustment: null,
            pendingRestoreAdjustment: null,
            warehouses: [],
            showEditAmount: false,
            editAmountForm: {
                newAmount: null,
                warehouse: null
            },
        };
    },
    computed: {
        warehouseFilterOptions() {
            const warehouses = this.datafilter && Array.isArray(this.datafilter.Warehouses)
                ? this.datafilter.Warehouses
                : [];

            return [
                {
                    name: "Buscar en todos los almacenes",
                    value: "all",
                },
                ...warehouses,
            ];
        },
        selectedItemWarehouseName() {
            if ( this.form.warehouse && !this.selectedReport.WarehouseName ) {
                const warehouse = this.datafilter.Warehouses.find(current => {
                    return current.value === this.form.warehouse;
                });

                if (!warehouse) {
                    return '';
                }

                return warehouse.name;
            } else {
                return this.selectedReport.WarehouseName
            } 
        },
        totalStock() {
            const currentStock = Number(this.selectedReport && this.selectedReport.TotalStock) || 0;
            const quantity = Number(this.form.quantity);

            if (!Number.isFinite(quantity) || quantity < 0) {
                return currentStock;
            }

            return this.form.add ? currentStock + quantity : currentStock - quantity;
        },
        getsetLote: {
            get () {
                return this.form.lote || "";
            },
            set (val) {
                this.form.lote = val || null;
            }
        },
        getsetAverageCost: {
        get () {
        
            return this.selectedReport.CostoPromedio || 0
        
        },
        set (val) {
        
        
            this.form.price = val
            
        }
        },
        getsetWarehouse: {
          
          get () {        
           
              return this.selectedReport.Warehouse
           
          },
          set (val) {
            // alert(val)
            if (val=="") {
              this.form.warehouse = this.selectedReport.Lote
            } else {
              this.form.warehouse = val
            }
            
          }
        },
        stockToShow() {
            return this.selectedReport.TotalStock ? this.selectedReport.TotalStock : 0;
        },
        isValidQuantity() {
            const quantity = Number(this.form.quantity);
            return Number.isFinite(quantity) && quantity > 0;
        },
        hasAdjustmentDate() {
            return typeof this.form.date === "string" && this.form.date.trim().length > 0;
        },
        quantityRules() {
            return [
                value => Number(value) >= 0 || "La cantidad no puede ser negativa.",
            ];
        },
    },
    
    methods: {
        openAdjustment(item) {
            this.selectedReport = item;
            this.form = {
                ...createAdjustmentForm(),
                warehouse: item.ID_Warehouse,
                lote: item.Lote || null,
            };
            this.showReport = true;
        },
        normalizeQuantity(value) {
            if (value !== null && value !== "" && Number(value) < 0) {
                this.form.quantity = null;
            }
        },
        mapCostoPromedio(response) {
            return response.map((item) => {
                item.CostoPromedio = item.CostoPromedio || 0;
                return item;
            });
        },
        stripHtml(value) {
            if (value == null) {
                return "";
            }

            return String(value).replace(/<[^>]*>/g, "").trim();
        },
        formatDisplayDate(value) {
            if (!value) {
                return "";
            }

            if (typeof value === "string") {
                const normalized = value.trim();
                const datePart = normalized.slice(0, 10);

                if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
                    const [year, month, day] = datePart.split("-");
                    return `${day}/${month}/${year}`;
                }

                if (/^\d{2}\/\d{2}\/\d{4}$/.test(datePart)) {
                    return datePart;
                }
            }

            const parsedDate = new Date(value);
            if (!Number.isNaN(parsedDate.getTime())) {
                const day = String(parsedDate.getDate()).padStart(2, "0");
                const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
                const year = parsedDate.getFullYear();
                return `${day}/${month}/${year}`;
            }

            return String(value);
        },
        verifyR() {
            if (!this.selectedReport) {
                this.showAlert("warning", "Ajuste de inventario", "Seleccione un producto");
                return;
            }
            this.showReport = true;
        },
        getDefaultAdjustmentDates() {
            const today = new Date();
            const from = new Date(today);
            from.setDate(today.getDate() - 30);

            const formatDate = (date) => {
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            };

            return {
                startDate: formatDate(from),
                endDate: formatDate(today),
            };
        },
        setDefaultAdjustmentFilters() {
            this.adjustmentHistoryFilters = {
                filterByDate: true,
                ...this.getDefaultAdjustmentDates(),
                warehouseId: "all",
                searchTerm: "",
            };
        },
        openAdjustmentsManager(item) {
            this.selectedReport = item;
            this.pendingRevertAdjustment = null;
            this.pendingRestoreAdjustment = null;
            this.adjustmentsData = [];
            this.deletedAdjustmentsData = [];
            this.adjustmentsTab = 0;
            this.setDefaultAdjustmentFilters();
            this.showAdjustmentsManager = true;
            this.loadAdjustments();
        },
        resetAdjustmentFilters() {
            this.adjustmentsData = [];
            this.deletedAdjustmentsData = [];
            this.setDefaultAdjustmentFilters();
            if (this.adjustmentsTab === 1) {
                this.loadDeletedAdjustments();
                return;
            }
            this.loadAdjustments();
        },
        getAdjustmentBatchFilter() {
            return this.selectedReport.ID_ItemBatch
                || (this.selectedReport.Lote && this.selectedReport.Lote !== "Por defecto" ? this.selectedReport.Lote : null);
        },
        getAdjustmentFilterParams() {
            const params = {
                productId: this.selectedReport.ID_Item,
                warehouseId: this.adjustmentHistoryFilters.warehouseId,
                itemBatch: this.getAdjustmentBatchFilter(),
            };

            const searchTerm = String(this.adjustmentHistoryFilters.searchTerm || "").trim();
            if (searchTerm) {
                params.search = searchTerm;
            }

            if (this.adjustmentHistoryFilters.filterByDate) {
                params.startDate = this.adjustmentHistoryFilters.startDate;
                params.endDate = this.adjustmentHistoryFilters.endDate;
            }

            return params;
        },
        loadAdjustments() {
            if (!this.selectedReport) {
                this.showAlert("warning", "Gestión de Ajustes", "Seleccione un producto");
                return;
            }

            this.adjustmentsData = [];
            this.adjustmentsLoading = true;
            this.$API.inventoryReports
                .getPhysicalStockAdjustments({
                    ...this.getAdjustmentFilterParams(),
                })
                .then((response) => {
                    this.adjustmentsData = Array.isArray(response) ? response : [];
                })
                .catch((error) => {
                    this.showAlert("danger", "Gestión de Ajustes", error || "No fue posible cargar los ajustes");
                })
                .finally(() => {
                    this.adjustmentsLoading = false;
                });
        },
        loadDeletedAdjustments() {
            if (!this.selectedReport) {
                this.showAlert("warning", "Gestión de Ajustes", "Seleccione un producto");
                return;
            }

            this.deletedAdjustmentsData = [];
            this.adjustmentsLoading = true;
            this.$API.inventoryReports
                .getDeletedPhysicalStockAdjustments({
                    ...this.getAdjustmentFilterParams(),
                })
                .then((response) => {
                    this.deletedAdjustmentsData = Array.isArray(response) ? response : [];
                })
                .catch((error) => {
                    this.showAlert("danger", "Gestión de Ajustes", error || "No fue posible cargar el historial de reversiones");
                })
                .finally(() => {
                    this.adjustmentsLoading = false;
                });
        },
        askRevertAdjustment(adjustment) {
            this.pendingRevertAdjustment = adjustment;
            this.pendingRestoreAdjustment = null;
            this.showAdjustmentsManager = false;
            this.showAlert(
                "question2",
                "Revertir ajuste",
                `Va a revertir el ajuste ${adjustment.ID_Adjustment}. Esta operación eliminará el ajuste y restaurará el inventario.`,
                "revert-physical-adjustment"
            );
        },
        askRestoreAdjustment(adjustment) {
            this.pendingRestoreAdjustment = adjustment;
            this.pendingRevertAdjustment = null;
            this.showAdjustmentsManager = false;
            this.showAlert(
                "question2",
                "Restaurar ajuste",
                `Va a restaurar el ajuste ${adjustment.ID_Adjustment} desde el historial de reversiones.`,
                "restore-physical-adjustment"
            );
        },
        refreshAdjustmentsManagerData() {
            if (this.adjustmentsTab === 1) {
                this.loadDeletedAdjustments();
                this.loadAdjustments();
                return;
            }

            this.loadAdjustments();
            this.loadDeletedAdjustments();
        },
        revertSelectedAdjustment(allowNegative = false) {
            if (!this.pendingRevertAdjustment) {
                return;
            }

            this.adjustmentsLoading = true;
            const adjustment = this.pendingRevertAdjustment;

            this.$API.inventoryReports
                .revertPhysicalStockAdjustment({
                    ID_Adjustment: adjustment.ID_Adjustment,
                    allowNegative,
                })
                .then(() => {
                    this.showAlert(
                        "success",
                        "Gestión de Ajustes",
                        "Ajuste revertido correctamente"
                    );
                    this.pendingRevertAdjustment = null;
                    this.refreshAdjustmentsManagerData();
                    this.refreshMainReportAfterAdjustment();
                })
                .catch((error) => {
                    if (error && error.requiresConfirmation) {
                        this.showAlert(
                            "question2",
                            "Confirmar reversión",
                            error.message || "La reversión dejaría el inventario en negativo. ¿Desea continuar?",
                            "confirm-negative-revert"
                        );
                        return;
                    }
                    this.showAlert(
                        "danger",
                        "Gestión de Ajustes",
                        (error && error.message) || error || "No fue posible revertir el ajuste"
                    );
                })
                .finally(() => {
                    this.adjustmentsLoading = false;
                });
        },
        restoreSelectedAdjustment(allowNegative = false) {
            if (!this.pendingRestoreAdjustment) {
                return;
            }

            this.adjustmentsLoading = true;
            const adjustment = this.pendingRestoreAdjustment;

            this.$API.inventoryReports
                .restorePhysicalStockAdjustment({
                    ID_Adjustment: adjustment.ID_Adjustment,
                    allowNegative,
                })
                .then(() => {
                    this.showAlert(
                        "success",
                        "Gestión de Ajustes",
                        "Ajuste restaurado correctamente"
                    );
                    this.pendingRestoreAdjustment = null;
                    this.refreshAdjustmentsManagerData();
                    this.refreshMainReportAfterAdjustment();
                })
                .catch((error) => {
                    if (error && error.requiresConfirmation) {
                        this.showAlert(
                            "question2",
                            "Confirmar restauración",
                            error.message || "La restauración dejaría el inventario en negativo. ¿Desea continuar?",
                            "confirm-negative-restore"
                        );
                        return;
                    }
                    this.showAlert(
                        "danger",
                        "Gestión de Ajustes",
                        (error && error.message) || error || "No fue posible restaurar el ajuste"
                    );
                })
                .finally(() => {
                    this.adjustmentsLoading = false;
                });
        },
        refreshMainReportAfterAdjustment() {
            if (this.cacheData && Object.keys(this.cacheData).length > 0) {
                this.reloadDatawithParams();
                return;
            }

            this.getEarningDetail();
        },
        closeAlert() {
            this.alert.show = false;
            this.loading = false
            this.pendingRevertAdjustment = null;
            this.pendingRestoreAdjustment = null;
        },
        acceptAlert() {
            if (this.alert.options === "revert-physical-adjustment") {
                this.alert.show = false;
                this.revertSelectedAdjustment();
                return;
            }
            if (this.alert.options === "confirm-negative-revert") {
                this.alert.show = false;
                this.revertSelectedAdjustment(true);
                return;
            }
            if (this.alert.options === "restore-physical-adjustment") {
                this.alert.show = false;
                this.restoreSelectedAdjustment();
                return;
            }
            if (this.alert.options === "confirm-negative-restore") {
                this.alert.show = false;
                this.restoreSelectedAdjustment(true);
                return;
            }
            this.alert.show = false;
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        reloadDatawithParams(){
            this.cacheData.fromAdjustment = true;
            this.$API.inventoryReports.getInventoryFilterReportColumn(this.cacheData).then(response => {
                this.reportsData = this.mapCostoPromedio(response);
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
            
        },
        sendAdjustment() {
            if (this.loading) {
                return;
            }
            if (!this.isValidQuantity) {
                return this.showAlert(
                    "warning",
                    "Ajuste de inventario",
                    "Ingrese una cantidad mayor que cero."
                );
            }
            if (!this.hasAdjustmentDate) {
                return this.showAlert(
                    "warning",
                    "Ajuste de inventario",
                    "Seleccione una fecha para el ajuste."
                );
            }
            if (!this.form.warehouse) {
                this.form.warehouse =  this.selectedReport.Warehouse
            }
            if(this.form.warehouse == null){
                return this.showAlert(
                    "warning",
                    "Ajuste de inventario",
                    "Seleccione un almacén"
                );
            }
            if(this.totalStock < 0){
                return this.showAlert(
                    "warning",
                    "Ajuste de inventario",
                    "No se puede realizar un ajuste negativo"
                );
            }
            this.loading = true;
            if (!this.form.lote) {
          this.form.lote =  this.selectedReport.Lote
        } 
        if (!this.form.price) {
          this.form.price =  this.selectedReport.CostoPromedio || 0
        } 
        //alert(this.form.lote);
            this.$API.inventoryReports
                .sendAdjustment({
                    item: this.selectedReport,
                    adjustmentParams: this.form,
                })
                .then((response) => {
                    //this.loading = false;
                    const warning = response && response.externalStoreSyncWarning;
                    this.showAlert(
                        warning ? "warning" : "success",
                        "Ajuste de inventario",
                        warning ? "Ajuste realizado correctamente. " + warning : "Ajuste realizado correctamente",
                        "reloadwithalert"
                    );
                    console.log(response);
                    this.form = createAdjustmentForm();
                    this.selectedReport = null;
                    this.showReport = false;
                })
                .catch((error) => {
                    this.loading = false;
                    this.showAlert(
                        "danger",
                        "Ajuste de inventario",
                        (error && error.message) || error || "No fue posible realizar el ajuste"
                    );
                });
        },
        updateCache(data) {
            this.cacheData = data;
        },
        selectionChanged(e) {
            var selectedRows = e.selectedRowsData;
            if (selectedRows.length > 0) {
                this.selectedReport = selectedRows[0];
            }
        },

        getEarningDetail() {
            
            
            this.loading = true;
            this.$API.inventoryReports
                .getInventoryReport()
                .then((response) => {
                    this.loading = false;
                    this.reportsData = this.mapCostoPromedio(response);
                    this.selectedReport = null;
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                });
        },
        onExporting(e) {
            printToExcel(e, "Reporte de Existencias (Informe Físico)");
        },
        filterHandler(response) {
            this.reportsData = this.mapCostoPromedio(response);
        },
        cleanFilter() {
            this.filterParams = {
                ID_Item: null,
                ItemName: null,
                ItemLote: null,
                providersNames: null,
                WarehouseName: null,
            };
            this.getEarningDetail();
        },
        getFilterEarningDetail() {
            this.loading = true;
            this.$API.inventoryReports
                .getInventoryFilterReport(this.filterParams)
                .then((response) => {
                    this.loading = false;
                    this.reportsData = this.mapCostoPromedio(response);
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                });
        },
        changueDt(date) {
            this.form.date = date;
        },
        assignParams() {
            if (this.datafilter) {
                this.columsConfig[0].options = this.datafilter.Warehouses;
                this.columsConfig[1].options = this.datafilter.Families;
                this.columsConfig[2].options = this.datafilter.Categories;
                this.columsConfig[3].options = this.datafilter.SubCategories;
                this.columsConfig[4].options = this.datafilter.batches;
                this.Reloadfilter += 1;
            }
        },
        handleEditAmountSave({ id, newAmount, warehouse, dateStart, noDate }) {
            this.loading = true;
             this.$API.inventoryReports.updatePhysicalStockCost({
                productId: id,
                warehouseId: warehouse,
                newCost: newAmount,
                dateStart: dateStart,
                noDate
            })
            .then(() => {
                //this.loading = false;
                this.showAlert(
                    "success",
                    "Ajuste de inventario",
                    "Costo actualizado correctamente",
                    "reloadwithalert"
                );
                this.form = {};
                this.selectedReport = null;
                //this.getFilterEarningDetail()
            })
            .catch((error) => {
                this.loading = false;
                this.showAlert(
                    "danger",
                    "Error",
                    error || "Error actualizando el costo"
                );
            });
        },
    },
    watch: {
        showReport(isOpen) {
            if (!isOpen) {
                this.form.quantity = null;
            }
        },
        adjustmentsTab(newValue) {
            if (newValue === 1 && !this.deletedAdjustmentsData.length && this.selectedReport) {
                this.loadDeletedAdjustments();
            }
        },
    },
    mounted() {
        this.assignParams()
      
    },
};
</script>

<style scoped>
::v-deep .inventory-adjustments-modal {
    z-index: 3000 !important;
}

::v-deep .inventory-adjustments-alert-dialog {
    z-index: 10000 !important;
}

::v-deep .inventory-adjustments-alert .block-wrapper {
    position: fixed !important;
    z-index: 10001 !important;
}

::v-deep .inventory-adjustment-dialog {
    z-index: 1000 !important;
}
</style>

<style scoped>
.btnblack {
    background-color: rgba(60, 60, 60, 1) !important;
    color: white !important;
}

.close-btn {
    color: white !important;
    position: relative !important;
    float: right !important;
}

.border {
  border-radius: 15px !important;
}

.action-btns-gap {
  display: flex;
  gap: 0.5rem;
}
</style>
